<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="select_container">
      <el-input v-model="input" placeholder="机构名称" style="width: 200px"></el-input>
      <el-button type="primary" @click="searchQuery()">搜索</el-button>
      <!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量回款</el-button>-->
      <el-select v-model="value" placeholder="默认排序" style="float: right;width: 200px"  @change="change" >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.label"
          :value="item.id">
        </el-option>
      </el-select>
    </div>

    <div class="table_container">
      <el-table
        :data="tableData"
        @selection-change="selsChange"
        highlight-current-row
        style="width: 100%">
        <el-table-column
          type="selection"
          :selectable="selectable"
          width="55">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          property="organizationName"
          label="机构名称">
        </el-table-column>
        <el-table-column
          property="countMoney"
          label="收入总计">
        </el-table-column>
        <el-table-column
          property="monthMoney"
          label="本月收入">
        </el-table-column>
        <el-table-column
          property="userCount"
          label="会员人数">
        </el-table-column>
        <el-table-column
          :formatter="formatDate"
          property="createTime"
          label="合作时间">
        </el-table-column>
        <el-table-column
          property="bkMoney"
          label="返利金额">
        </el-table-column>
        <!--<el-table-column label="上月回款" width="200">-->
          <!--<template slot-scope="scope">-->
            <!--<el-button v-if="scope.row.back==null" @click="backPayment(scope.$index, scope.row)" type="text" size="small">回款确认</el-button>-->
            <!--<span v-if="typeof (scope.row.back) =='number'">已回款</span>-->
          <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-button @click="rebate(scope.$index, scope.row)" type="text" size="small">修改返利</el-button>
            <el-button @click="handleClick(scope.$index, scope.row)" type="text" size="small">查看</el-button>
            <el-button @click="intuer(scope.$index, scope.row)" type="text" size="small">机构用户</el-button>
            <!--<el-button type="text" size="small">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>

      <el-dialog title="修改返利" :visible.sync="dialogFormVisible" v-loading="loading">
        <el-form label-width="160px" ref="addForm">
          <el-form-item label="每位机构会员返利金额">
            <el-input v-model="num" autocomplete="off" maxlength="8"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addSubmit()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getInstitutional,getMoneyback,getModrebate } from "../api/api"
  export default {
    data(){
      return {
        value: '',
        tableData: [],
        sels: [],
        limit: 20,
        total: 0,
        currentPage: 1,
        input: '',
        sort: '',
        dialogFormVisible:false,
        options:[{
            id: '',
            label: '默认排序'
          },{
            id: '1',
            label: '收入总计从低到高'
          },{
            id: '2',
            label: '收入总计从高到低'
          }
        ],
        num:'',
        id:'',
        loading:false
      }
    },
    components: {
      headTop,
    },
    activated(){
      this.getInstitutional();
    },

    methods: {
      //时间戳转换
      formatDate:function (value){
        var dateee = new Date(value.createTime).toJSON();
        return new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
      },
      getInstitutional(){
        //机构用户列表
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
          organizationName:this.input,
          sort:this.sort
        };
        //机构用户列表
        getInstitutional(params).then(res=>{
          this.tableData = res.pageInfo
          this.total = res.total
          for (let i = 0;i < res.pageInfo.length;i++){
            if (res.pageInfo[i].countMoney == null){
              res.pageInfo[i].countMoney = 0
            }
            if (res.pageInfo[i].monthMoney == null){
              res.pageInfo[i].monthMoney = 0
            }
          }
        }).catch(error=>{
          console.log(error);
        })

      },
      searchQuery(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
          organizationName:this.input,
          sort:this.sort
        };
        //机构用户列表
        getInstitutional(params).then(res=>{
          this.tableData = res.pageInfo
          this.total = res.total
        }).catch(error=>{
          console.log(error);
        })
      },
      backPayment(index, row){
        //回款确认
        this.$confirm('确认回款给机构吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            userId:row.userId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            batch:false,
            backTime:row.createTime
          };
          getMoneyback(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              row.back = 0
            }else{
              throw new Error(res.message)
            }
          }).catch(error=>{
            this.$message({
              type: 'error',
              message: res.msg
            });
          })
        }).catch(() => {
        })
      },
      change(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
          organizationName:this.input,
          sort:this.value
        };
        //获取排版管理列表
        getInstitutional(params).then(res=>{
          this.total = res.total
          this.tableData = res.pageInfo
          for (let i = 0;i < res.pageInfo.length;i++){
            if (res.pageInfo[i].countMoney == null){
              res.pageInfo[i].countMoney = 0
            }
            if (res.pageInfo[i].monthMoney == null){
              res.pageInfo[i].monthMoney = 0
            }
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      selectable(row, index){
        if(typeof (row.back) == 'number'){
          return false;
        }else{
          return true;
        }
      },

      selsChange: function (sels) {
        this.sels = sels;
      },
      batchRemove: function () {
        //批量回款
        var ids = this.sels.map(item => item.userId).toString();
        this.$confirm('确认回款给机构吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            userId:ids,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            batch:true,
          };
          getMoneyback(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.getInstitutional()
            }else{
              throw new Error(res.message)
            }
          }).catch(error=>{
            this.$message({
              type: 'error',
              message: res.msg
            });
          })
        }).catch(() => {
        })
      },

      handleClick(index,row){
        this.$router.push({
          path: 'intuserDetail',
          query:{
            id:row.userId
          }
        });
      },
      intuer(index,row){
        this.$router.push({
          path: 'institution',
          query:{
            id:row.userId
          }
        });
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getInstitutional()
      },
      rebate(index,row){
        this.id = row.userId
        this.num = row.bkMoney
        this.dialogFormVisible = true
      },
      addSubmit(){
        if (this.num == '' || this.num <=0){
          this.$message({
            type: 'error',
            message: '请输入正确金额'
          });
        } else {
          let params = {
            userId: this.id,
            operationId: JSON.parse(sessionStorage.getItem('user')).id,
            bkMoney:this.num
          };
          getModrebate(params).then(res => {
            if (res.state == true){
              this.getInstitutional()
              this.dialogFormVisible = false
            } else {
              this.$message({
                type: 'error',
                message: '请输入正确返现金额'
              });
            }
          }).catch(error => {
            console.log(error);
          })
        }
      }
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
</style>




// WEBPACK FOOTER //
// src/page/intuser.vue